import * as core from '../../../../../../../core'

import { query } from './outcome-explore-external-src.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcome-explore-external-src',
    description:
      'Displays external sources about the currently focused outcome, if there are any',
    name: 'Summit - Outcome Explore External Source',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
